import React, { useEffect, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import {
  Box,
  FormControl,
  TextField,
} from "@material-ui/core";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  GetDeteriorationCurve,
  UploadDeteriorationCurve,
  UploadSurveyedData,
} from "../../../services/actions/RoadAction";
import { FileInput } from "./UploadForm";
import i18n from "../../../localization/i18n";
import { Trans } from "react-i18next";
import MaterialTable from "material-table";
import Papa from "papaparse";
import Swal from "sweetalert2";

const EditDialog = ({
  handleClose,
  open,
  loggedUser,
  initDeteriorationCurveList,
}) => {
  const dispatch = useDispatch();
  const [dataFile, setDataFile] = useState(null);
  const [deleteDeteriorationCurveList, setDeleteDeteriorationCurveList] = useState([]);
  const [deteriorationCurveList, setDeteriorationCurveList] = useState([]);

  const downloadCSVFormat = () => {
    const headers = ["spm", "year"];
    const csv = Papa.unparse([headers]);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "format.csv";
    link.click();
  };

  const register = () => {
    const newDeteriorationCurveList = [];
    deteriorationCurveList.forEach((deteriorationCurve) => {
      const yearList = [];
      const spmList = [];
      if (!deteriorationCurve.uploadDataList && !deteriorationCurve.updateFlag)
        return;
      if (deteriorationCurve.uploadDataList) {
        deteriorationCurve.uploadDataList.forEach((uploadData) => {
          if (uploadData.year != null && uploadData.spm != null) {
            yearList.push(uploadData.year);
            spmList.push(uploadData.spm);
          }
        });
        newDeteriorationCurveList.push({
          UserId: loggedUser.id,
          XYear: `[${yearList ? yearList.join(",") : ""}]`,
          YSpm: `[${spmList ? spmList.join(",") : ""}]`,
          Title: deteriorationCurve.title,
          CsvName: deteriorationCurve.csvName,
        });
      } else {
        newDeteriorationCurveList.push({
          Id: deteriorationCurve.id,
          UserId: loggedUser.id,
          XYear: deteriorationCurve.xYear,
          YSpm: deteriorationCurve.ySpm,
          Title: deteriorationCurve.title,
          CsvName: deteriorationCurve.csvName,
        });
      }
    });
    dispatch(
      UploadDeteriorationCurve({
        deteriorationCurveList: newDeteriorationCurveList,
        deleteDeteriorationCurveList: deleteDeteriorationCurveList,
      })
    ).then(() => {
      setDeleteDeteriorationCurveList([]);
      setDeteriorationCurveList([]);
      dispatch(GetDeteriorationCurve());
    });
  };

  useEffect(() => {
    dispatch(GetDeteriorationCurve());
  }, [open]);

  useEffect(() => {
    setDeteriorationCurveList(
      JSON.parse(JSON.stringify(initDeteriorationCurveList))
    );
  }, [initDeteriorationCurveList]);

  return (
    <Dialog fullWidth maxWidth="sm" open={open} disableBackdropClick={true}>
      <DialogTitle style={{ backgroundColor: "#E28020", color: "white" }}>
        {i18n.t("deterioration_curve_list")}
      </DialogTitle>
      <DialogContent dividers style={{ textAlign: "center" }}>
        <Box
          className="upload-container"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          style={{ boxShadow: "none", width: "100%" }}
        >
          <FormControl width="30%">
            <FileInput
              id="deterioration_curve_master_data"
              label={<Trans>label_data</Trans>}
              tooltip={i18n.t("tooltip_select_csv_file")}
              placeholder={i18n.t("tooltip_select_csv_file")}
              value={dataFile}
              multiple={false}
              fileOptions={{ accept: ".csv" }}
              onChange={(files) => {
                if (files && files[0]) {
                  const newFiles = [
                    ...Object.keys(files)
                      .map((key) => files[key])
                      .filter(
                        (file) =>
                          file.name.includes("csv") &&
                          !(dataFile || []).some((x) => x.name === file.name)
                      ),
                  ];
                  if (!newFiles || !newFiles[0]) return;
                  let id = 1;
                  if (deteriorationCurveList.length > 0) {
                    id =
                      deteriorationCurveList[deteriorationCurveList.length - 1]
                        .id + 1;
                  }
                  Papa.parse(newFiles[0], {
                    complete: function (results) {
                      const data = results.data;
                      const newTableData = {
                        id: id,
                        title: `Title_${deteriorationCurveList.length + 1}`,
                        csvName: newFiles[0].name,
                        uploadDataList: data,
                      };
                      setDeteriorationCurveList((_deteriorationCurveList) => [
                        ..._deteriorationCurveList,
                        newTableData,
                      ]);
                      setDataFile(null);
                    },
                    header: true,
                    skipEmptyLines: true,
                  });
                }
              }}
              deleteItem={() => {
                setDataFile(null);
              }}
            />
          </FormControl>
          <FormControl width="40%">
            <Button
              color="primary"
              variant="contained"
              width="100%"
              style={{ margin: "10px", background: "#FFC000" }}
              onClick={downloadCSVFormat}
            >
              {i18n.t("format_csv_download")}
            </Button>
          </FormControl>
        </Box>
        <MaterialTable
          columns={[
            {
              title: "No.",
              // field: "id",
              render: (rowData) => rowData.tableData.id + 1,
              width: "8%"
            },
            {
              title: "Title",
              field: "title",
              width: "40%",
              render: (rowData) => {
                const index = deteriorationCurveList.findIndex(
                  (data) => data.id == rowData.id
                );
                return (
                  <TextField
                    value={
                      (index > -1 && deteriorationCurveList[index]?.title) || ""
                    }
                    onChange={(e) => {
                      const index = deteriorationCurveList.findIndex(
                        (data) => data.id == rowData.id
                      );
                      if (index > -1) {
                        deteriorationCurveList[index].title = e.target.value;
                        deteriorationCurveList[index].updateFlag = true;
                        setDeteriorationCurveList([...deteriorationCurveList]);
                      }
                    }}
                    style={{ height: "30px", padding: "0 8px" }}
                  />
                );
              },
            },
            { title: "CSV", field: "csvName", width: "40%" },
          ]}
          data={deteriorationCurveList}
          actions={[
            {
              icon: "delete",
              tooltip: "Delete Data",
              onClick: (_e, rowData) => {
                Swal.fire({
                  title: i18n.t("delete_confirm_message", { id: rowData.tableData.id + 1 }),
                  showCancelButton: true,
                  confirmButtonText: `Yes`,
                }).then((result) => {
                  if (result.value) {
                    setTimeout(() => {
                      setDeteriorationCurveList((deteriorationCurveList) =>
                        deteriorationCurveList.filter(
                          (data) => data.id !== rowData.id
                        )
                      );
                      if (!rowData.uploadDataList) {
                        setDeleteDeteriorationCurveList(
                          (deleteDeteriorationCurveList) => [
                            ...deleteDeteriorationCurveList,
                            rowData.id,
                          ]
                        );
                      }
                    }, 1000);
                  }
                });
              },
            },
          ]}
          localization={{
            header: {
              actions: 'Action',
            }
          }}
          options={{
            rowStyle: (rowData) => ({
              backgroundColor: "#FFF",
            }),
            actionsColumnIndex: 1,
            search: false,
            toolbar: false,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={register} color="primary" variant="contained">
          Save
        </Button>
        <Button onClick={handleClose} color="default" variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(
  (state) => ({
    loggedUser: state.auth.user,
    initDeteriorationCurveList: state.road.deteriorationCurveList,
  }),
  (dispatch) => ({
    UploadSurveyedData: (data, callback) =>
      dispatch(UploadSurveyedData(data, callback)),
  })
)(EditDialog);
